import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_13: R2BReferralBrandEntity = {
  token: "r2b_referral_13",
  type: "r2bReferralBrand",
  name: "Meridian Supply",
  email: "anna.kowalski@example.com",
  website: "meridiansupply.com",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
